<template>
  <div class="description">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FrrDescription',
};
</script>

<style lang="sass" scoped src="./FrrDescription.sass"></style>
